<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent" id="ack"><a id="page_v"></a><span class="small">ACKNOWLEDGMENTS:</span> The essay by Simone de Beauvoir “Must We Burn Sade?” was originally published in the December 1951 and January 1952 issues of <em>Les Temps Modernes</em> as “Faut-il brûler Sade?” and was subsequently reprinted in the collection of the author’s essays entitled <em>Privilèges</em>. The English translation first appeared in <em>The Marquis de Sade,</em> published by Grove Press in 1954, and is here reprinted in a slightly revised translation by permission of the publisher and the translator. “Nature as Destructive Principle,” by Pierre Klossowski, served as an introduction to the <em>Au Cercle du Livre Précieux</em> edition of <em>Les 120 Journées de Sodome.</em> This essay is a slightly revised and condensed version of the chapter entitled “Esquisse du Système” from the author’s book, <em>Sade mon prochain,</em> published by <em>Editions du Seuil,</em> Paris, France, 1947. It is here reprinted by permission of the author and of the editor of <em>Yale French Studies.</em> The editors wish especially to thank Miss Marilynn Meeker for her meticulous job of editing, and for the number and diversity of her suggestions.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgment.vue?633406ba